<template>
  <font-awesome-icon
    @click="onClick"
    class="chevron opacity"
    :icon="icon"/>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import { faChevronCircleLeft } from '@fortawesome/fontawesome-free-solid';

export default {
  name: 'Chevron',
  components: {
    FontAwesomeIcon
  },
  data () {
    return {
      icon: faChevronCircleLeft
    };
  },
  methods: {
    onClick (event) {
      this.$emit('click', event);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../stylesheets/variables";

.chevron {
  font-size: $fs-2xl;
  color: $jamaicol;
  margin-left: auto;
  margin-right: $sp-margin-smaller;
  cursor: pointer;
}

.opacity:hover {
  opacity: 0.3;
  transition: opacity 0.3s;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/shared/Chevron.vue